export { default as DefaultPage } from './DefaultPage';
export { default as DefaultPageTrain } from './DefaultPageTrain';
export { default as ServiceItem } from './ServiceItem/ServiceItem';
export { default as CoachLayout } from './CoachLayout/CoachLayout';
export { default as SelectedServiceMore } from './SelectedServiceMore/SelectedServiceMore';
export { default as PaymentDetailsPage } from './PaymentDetailsPage/PaymentDetailsPage';
export { default as PaymentRightSideBar } from './PaymentRightSideBar/PaymentRightSideBar';
export { default as TrainCoachLayout } from './TrainCoachLayout/TrainCoachLayout';



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/index.js